import { useCurrentStateAndParams } from '@uirouter/react';

import { ViewLoading } from '@@/ViewLoading';

import { useApplicationResource } from '../queries/useApplicationResource';
import { appTypeIsCustomResource } from '../utils';

import { ApplicationDetailsView } from './ApplicationDetailsView';
import { CustomResourceDetailsView } from './CustomResourceDetailsView';

export function DetailsView() {
  const stateAndParams = useCurrentStateAndParams();
  const {
    params: {
      'resource-type': resourceTypeParam,
      namespace,
      name,
      endpointId: environmentId,
    },
  } = stateAndParams;

  // Get the application data to determine if it's a custom resource or not,
  // but only if we don't already have a resource type param
  const { data: application, isInitialLoading } = useApplicationResource(
    environmentId,
    namespace,
    name,
    resourceTypeParam,
    {
      enabled: !resourceTypeParam,
    }
  );

  // If we already know the resource type from URL params, render directly.
  if (resourceTypeParam) {
    return appTypeIsCustomResource(resourceTypeParam as string) ? (
      <CustomResourceDetailsView resourceType={resourceTypeParam} />
    ) : (
      <ApplicationDetailsView />
    );
  }

  // If we don't know the resource type from URL params we need to load the application
  // to see whether it's a custom resource or not.
  if (isInitialLoading) {
    return <ViewLoading message="Loading..." />;
  }

  return application?.ApplicationType &&
    appTypeIsCustomResource(application.ApplicationType) ? (
    <CustomResourceDetailsView resourceType={application.ApplicationType} />
  ) : (
    <ApplicationDetailsView />
  );
}
